import DetailsGrid from './DetailsGrid';

export default DetailsGrid;
